<template>
  <div class="login-wrapper">
    <img :src="loginBg" alt="" class="login-bg">
    <div class="login-business">
      <!-- <div class="top"></div>-->
      <!-- <div class="bottom">
        <a href="">
          长城官网 | 使用帮助    copyright @2019 长城智能出行
        </a>
      </div> -->
      <div class="content">
        <div class="brand">长城汽车车联网综合管理系统</div>
        <div class="brand2">专注  专业  专家</div>
        <!-- <lang-drop-menu class="login-lang"></lang-drop-menu> -->
        <!-- <div class="bg-img">
          <img :src="loginImg"/>
        </div> -->
        <img :src="loginLogo" class="login-logo"/>
        <img :src="loginCar" class="login-car"/>
        <div class="login-box-banner"  :style="'height: ' + '500' + 'px !important;'">
          <div class="login-box">
            <div class="login-inner">
              <transition name="fade">
                <div v-show="errorShow" class="error-message">{{description}}</div>
              </transition>
              <Form ref="loginForm" :model="admin" :rules="ruleValidate" class="login-form">
                <div class="login-tit">帐号密码登录</div>
                <FormItem prop="username">
                  <Input v-model.trim="admin.username" placeholder="账户名"
                         style="width: 100%" size="large" @on-enter="login" clearable />
                </FormItem>
                <FormItem prop="password">
                  <Input  type="password" v-model.trim="admin.password" autocomplete="new-password"
                          placeholder="密码"
                          style="width: 100%" size="large" @on-enter="login" clearable />
                </FormItem>
                <FormItem prop="sliderValue">
                  <SliderVerificationCode textColor='#000000' background='#e8e8e8' v-model="admin.sliderValue" @change="handleChangeSlider"/>
                </FormItem>
                <!-- 滚动条拖动至底时展示 -->
                
                <template v-if="admin.sliderValue && global.environment !== 'DEV' && global.environment !== 'test'">
                  <FormItem prop="smsCode">
                    <Input v-model.trim="admin.smsCode" maxlength="6" size="large" placeholder="请输入验证码" style="width:140px;" @on-enter="login" clearable></Input>
                    <div class="right">
                      <Button class="get_vcode" size="large" :loading="modalBtn" @click="getVcode" v-if="!waitingTime&&!waitingEnd">获取验证码</Button>
                      <Button class="get_vcode" size="large" disabled v-if="waitingTime&&!waitingEnd">{{waitingTime}}s后重试</Button>
                      <Button class="get_vcode" size="large" :loading="modalBtn" @click="getVcode" v-if="!waitingTime&&waitingEnd">重新获取</Button>
                    </div>
                  </FormItem>
                  <center style="color:#D5736C">当无法获取验证码时，请联系运营人员</center>
                </template>

                <FormItem class='remember'>
                  <Checkbox v-model="remember">记住我</Checkbox>
                  <!-- <a href="javascript:void(0)" @click="forgetPwdHander"
                     class="right login-forget">忘记密码?</a> -->
                </FormItem>
                <Button class="login-btn" size="large" long @click="login" :loading="loading">登录</Button>
              </Form>
            </div>
          </div>
        </div>
        <!-- <div class="login-ps">
          <div>{{$i18n.locale === 'zh-CN' ? global.login.copyright : global.login.copyright_en}}</div>
          <div>{{$t('SUGGEST_BROWSER')}}：Chrome、360、Firefox、Edge、IE11</div>
          <div>{{$t('SUGGEST_RESOLUTION')}}：1366x768</div>
        </div> -->
      </div>
    </div>
    <!--忘记密码之输入账户-->
    <Modal v-model="forgetPasswordModalShow" :mask-closable="false" title="忘记密码"
           @on-cancel="resetModal">
      <div>
        <Form label-position="right" :label-width="170">
          <FormItem label="账户名" prop="username">
            <Input v-model="queryUserName" placeholder="请输入账户名" class="m-width-200" />
            <p class="login-tips" v-if="userNameTips.length">{{userNameTips}}</p>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="userAccountConfirm" :disabled="!queryUserName.length || isNextStep">
          下一步
        </Button>
      </div>
    </Modal>
    <!--忘记密码之密码更改-->
    <Modal v-model="updatePasswordModalShow" :mask-closable="false" title="忘记密码"
           @on-cancel="resetUpdateModal">
      <div>
        <Form label-position="right" :label-width="150">
          <FormItem label="账户名">
            <span>{{queryUserName}}</span>
          </FormItem>
          <FormItem label="手机号" class="m-width-400">
            <span>{{queryUserPhone}}</span>
            <Button type="primary" v-if="!isSending" class="right" @click="sendVerifyCode">
              获取验证码
            </Button>
            <Button type="primary" v-else class="right" disabled>
              {{timeCountDown}} s
            </Button>
          </FormItem>
          <FormItem label="验证码">
            <Input v-model="verifyCode" placeholder="请输入验证码" class="m-width-250" />
            <img class="verify-tag" v-if="verifyRes === false" src="../../assets/img/verify_fail.png" alt=""/>
            <img class="verify-tag" v-if="verifyRes === true" src="../../assets/img/verify_success.png" alt=""/>
          </FormItem>
          <FormItem label="新密码">
            <Input type="password" onpaste="return false" v-model="newPwd" :disabled="!(verifyRes === true)" placeholder="请输入新密码" class="m-width-250" />
            <p class="login-tips" v-if="pwdTips.length">{{pwdTips}}</p>
          </FormItem>
          <FormItem label="确认密码">
            <Input type="password" onpaste="return false" v-model="newPwdRe" :disabled="!pwdVerify" placeholder="请确认新密码" class="m-width-250" />
            <p class="login-tips" v-if="pwdReTips.length">{{pwdReTips}}</p>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="reConfirmAccountHander">
          上一步
        </Button>
        <Button type="primary" @click="updatePwdSubmit" :disabled="!isCanSubmit">
          确认
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
// TODO 忘记密码，待定
import { mapGetters, mapMutations } from 'vuex';
import loginImg from '../../assets/img/login.png';
// import LangDropMenu from '../component/LangDropMenu';
import loginBg from '../../assets/img/login_bg.png';
import loginCar from '../../assets/img/login_car.png';
import loginLogo from '../../assets/img/logo.png';
import { httpAxios } from '../home/serve/header'
import * as api from '@/service'

  export default {
    components: {
      // LangDropMenu,
    },
    data() {
      return {
        loginBg,
        loginCar,
        loginLogo,
        admin: {
          username: localStorage[ 'login-username' ] ? localStorage[ 'login-username' ] : '',
          password: '',
          sliderValue: false,
          smsCode: '',
        },
        errorTimer: null,
        errorShow: false,
        description: '',
        remember: localStorage[ 'login-remember' ] ? Boolean(localStorage[ 'login-remember' ]) : false,
        loginImg,
        loading: false,
        modalBtn: false,
        forgetPasswordModalShow: false,
        queryUserName: '',
        userNameTips: '',
        isNextStep: false,
        updatePasswordModalShow: false,
        queryUserPhone: '',
        newPwd: '',
        newPwdRe: '',
        verifyCode: '',
        verifyRes: '',
        isSending: false,
        timeCountDown: 60,
        verifyTimer: null,
        isCanSubmit: false,
        pwdTips: '',
        pwdVerify: false,
        pwdReTips: '',
        waitingTime: null, // 验证码时间
        waitingEnd: false,
      };
    },
    computed: {
      ruleValidate() {
        return {
          username: [
            { required: true, message: '请输入 账户名' },
            { min: 3, max: 20, message: '账户名 长度 3 - 20' },
            { pattern: /^[A-Za-z0-9]+$/, message: '请输入正确的账户名' }
          ],
          password: [
            { required: true, message: '必填, 请输入密码' },
            { min: 8, max: 30, message: '密码 长度 8 - 30' },
            {
              pattern: /(^(?![0-9]+$)(?![A-Za-z]+$)[0-9A-Za-z]*$)|(^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]*$)/,
              message: '请输入字母数字或特殊字符'
            }
          ],
          sliderValue: [
            // { value: false, message: this.$t('SLIDER.required') },
            {
              validator: (rule, value, cb) => {
                if (!value) {
                  cb(new Error('请拖动 滑块'));
                }
                cb();
              },
            },
          ],
          smsCode: [
            { required: true, message: '请输入验证码' },
            { pattern: /^[0-9]+$/, message: '请输入数字验证码'}
          ],
        };
      },
      ...mapGetters({
        global: 'getGlobal',
        menuTabs: 'getMenuTabs',
      }),
    },
    methods: {
      ...mapMutations({
        setMenuTabs: 'SET_MENU_TABS',
        setActionTab: 'SET_ACTION_TAB',
      }),
      handleChangeSlider(value) {
        console.log(value)
        this.$refs.loginForm.validateField('sliderValue');
      },
      async login() {
        this.admin.username = this.admin.username.replace(/\s/g, '')
        const validate = await this.$refs.loginForm.validate()
        if (!validate) {
          return
        }
        this.loading = true
        let params = {
          accountName: this.admin.username,
          password: this.$md5(this.admin.password),
          smsType: 1,
          smsCode: this.admin.smsCode
        }
        
        const result = await api.login(params)
        this.loading = false
        if (result.data.code === '000000') {
          if (this.errorTimer) {
            clearTimeout(this.errorTimer);
            this.errorTimer = null;
          }
          sessionStorage['dashboard-token'] = result.data.data
          if (this.remember) {
            localStorage[ 'login-username' ] = this.admin.username;
            localStorage[ 'login-remember' ] = this.remember;
          }
          this.$router.push('/welcome?reason=login');
        } else {
          this.$Notice.warning({
            title: result.data.description
          })
        }
      },
      forgetPwdHander() {
        this.forgetPasswordModalShow = true;
      },
      resetModal() {
        this.queryUserName = '';
        this.forgetPasswordModalShow = false;
        this.userNameTips = '';
      },
      async userAccountConfirm() {
        // // 校验账户正确与否
        // const res = await _api_dashboard_service.get('/login/queryUserInfo', { params: { username: this.queryUserName } });
        // if (res.data.status === 'SUCCEED') {
        //   this.updatePasswordModalShow = true;
        //   this.forgetPasswordModalShow = false;
        //   this.queryUserPhone = res.data.datas.mobile;
        //   this.userId = res.data.datas._id;
        // } else {
        //   this.userNameTips = res.data.errorMessage;
        //   this.isNextStep = true;
        // }
      },
      resetUpdateModal() {
        this.updatePasswordModalShow = false;
        clearInterval(this.verifyTimer);
        this.timeCountDown = 60;
        this.isSending = false;
        this.queryUserName = '';
        this.queryUserPhone = '';
        this.verifyCode = '';
        this.newPwd = '';
        this.newPwdRe = '';
      },
      reConfirmAccountHander() {
        this.updatePasswordModalShow = false;
        this.forgetPasswordModalShow = true;
        this.timeCountDown = 60;
        this.isSending = false;
        this.pwdTips = '';
        this.pwdReTips = '';
        this.verifyRes = '';
        this.isCanSubmit = false;
        clearInterval(this.verifyTimer);
      },
      updatePwdSubmit() {
        // _api_dashboard_service.put('/login/updateUserPwd', {
        //   password: this.newPwd,
        //   _id: this.userId,
        // }).then(res => {
        //   if (res.data.status === 'SUCCEED') {
        //     this.$Notice.success10({
        //       title: '密码修改成功',
        //     });
        //     this.resetUpdateModal();
        //   } else {
        //     this.$Notice.warning10({
        //       title: '密码修改失败',
        //     });
        //   }
        // });
      },
      async sendVerifyCode() {
        this.timeCountDown = 60;
        this.isSending = true;
        this.verifyTimer = setInterval(() => {
          if (this.timeCountDown <= 0) {
            this.isSending = false;
            clearInterval(this.verifyTimer);
          } else {
            this.timeCountDown--;
          }
        }, 1000);
        // const res = await this.$ne.ajax.get('/gateway-api/verify/verif-code', {
        //   params: {
        //     eventId: this.queryUserPhone,
        //     eventType: 'FORGET_PASSWORD',
        //     verifyType: 'SMS',
        //   },
        // });
        // if (res.data.status === 'SUCCEED') {
        //   this.$Notice.success10({
        //     title: '发送短信验证码成功',
        //   });
        // } else {
        //   this.$Notice.warning10({
        //     title: '发送短信验证码失败',
        //   });
        // }
      },
      async verifyVerifyCode() {
        // const res = await this.$ne.ajax.get('/gateway-api/verify/verif-code/checkCode', {
        //   params: {
        //     eventType: 'FORGET_PASSWORD',
        //     eventId: this.queryUserPhone,
        //     code: this.verifyCode,
        //   },
        // });
        // if (res.data.status === 'SUCCEED') {
        //   this.verifyRes = true;
        // } else {
        //   this.verifyRes = false;
        // }
      },
      async getVcode() { // 获取短信验证码
        let self = this;
        this.$refs.loginForm.validateField('username',async value => {
          if(value){
            return;
          }
          if(!this.admin.username){
            return;
          }
          let params = {},i = 60;
          params.requestAccount = this.admin.username
          params.smsType = '1'
          if(this.timeOut){
            clearTimeout(this.timeOut)
          }
          this.timeOut = setTimeout(() => {
            if(this.waitingTime >= 59){
              return;
            }
            this.modalBtn = true;
            api.getSmsCode(params).then(res => {
              console.log(res)
              if(res.data.code  == '000000') {
                this.$Notice.success({
                  title: '验证码已发送',
                });
                this.timer = setInterval(() =>{
                  if(i > 0){
                    this.waitingEnd = false
                    this.waitingTime = i
                  }else{
                    this.waitingTime = null
                    this.waitingEnd = true
                    clearInterval(this.timer);
                  }
                  i --;
                },1000);
                this.modalBtn = false;
              } else {
                this.modalBtn = false;
                this.$Notice.warning({
                  title: res.data.description,
                });
              }
            })
          }, 500)
        });
      },

    },
    created() {
      console.log('============login============================')
      this.$store.commit('SET_RESOURCE', {});
      localStorage.removeItem('MeunsTabs');
      localStorage.removeItem('actionTab');
      this.setMenuTabs([]);
      this.setActionTab('');
      const reason = this.$route.query.reason;
      if (reason === 'expired') {
        this.$Message.warning('登录超时，请重新登录');
      } else if (reason === 'disable') {
        this.$Message.warning('登录超时，请重新登录');
      }
    },
    watch: {
      queryUserName: function(newVal) { //eslint-disable-line
        if (newVal.length === 0) {
          this.userNameTips = '';
          this.isNextStep = false;
        }
      },
      verifyCode: function(newVal) { //eslint-disable-line
        if (newVal.length === 6) {
          this.verifyVerifyCode();
        }
      },
      newPwd: function(newVal) { //eslint-disable-line
        if (newVal.length >= 6 && newVal.length <= 18) {
          this.pwdTips = '';
          this.pwdVerify = true;
        } else {
          this.pwdTips = '密码请保持在6-18位之间';
          this.pwdVerify = false;
        }
      },
      newPwdRe: function(newVal) { //eslint-disable-line
        if (newVal && this.newPwdRe === this.newPwd) {
          this.isCanSubmit = true;
          this.pwdReTips = '';
        } else {
          this.isCanSubmit = false;
          this.pwdReTips = '两次输入的密码不一致';
        }
      },
    },
    beforeCreate() {
     // httpAxios()
    },
  };
</script>
<style lang="less">
  @import '../../assets/less/variable';
  .app-drag {
    .slider {
      height: 100% !important;
    }
    .background {
      background-color: #bfbfbf !important;
    }
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    // -webkit-box-shadow: 0 0 0 30px white inset !important;
    background-color: #ffffff !important;
  }

  .login-wrapper {
    height: 100%;
    position: relative;
    overflow: hidden;
    min-height: 600px;
    .login-bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .login-business {
      height: 100%;
      // background: linear-gradient(90deg, @login-side-bgcolor, @login-center-bgcolor, @login-side-bgcolor);
      position: relative;
      .top,
      .bottom {
        left: -25%;
        position: absolute;
        width: 150%;
        display: none;
        // background-color: @login-bgcolor;
      }
      .top {
        top: 0;
        height: 28%;
        // border-bottom-right-radius: 70%;
        // border-bottom-left-radius: 70%;
        // box-shadow: 0 -18px 66px 20px #333;
      }
      .bottom {
        bottom: 0;
        height: 75px;
        text-align: center;
        line-height: 75px;
        background-color: #ffffff;
        font-size: 12px;
        font-family: PingFangSC-Regular;
        a {
          color: #868686;
          cursor: pointer;
          display: block;
        }
        // border-top-right-radius: 70%;
        // border-top-left-radius: 70%;
        // box-shadow: 0 28px 70px 20px #333;
      }
      .content {
        width: 1000px;
        height: 100%;
        margin: 0 auto;
        position: relative;
        z-index: 1;
        .brand {
          width: 100%;
          position: absolute;
          bottom: calc(55% + 60px);
          left: 0%;
          text-align: left;
          font-size: 36px;
          color: @login-color;
          // font-family: '微软雅黑';
          font-family: PingFangSC-Regular, sans-serif;
          letter-spacing: 4px;
          img {
            transform: translateY(24%);
            margin-right: 8px;
          }
        }
        .brand2 {
          width: 100%;
          position: absolute;
          bottom: calc(55% + 18px);
          left: 0%;
          text-align: left;
          font-size: 28px;
          color: #384049;
          // font-family: '微软雅黑';
          font-family: PingFangSC-Regular, sans-serif;
          letter-spacing: 4px;
        }
        .login-lang {
          a {
            color: @primary-color;
          }
          position: absolute;
          left: 472px;
          top: 24%;
          z-index: 1;
        }
        .bg-img {
          left: 1%;
          width: 100%;
          height: 354px;
          position: absolute;
          top: 23%;
          img {
            display: block;
            margin: 0 auto;
          }
        }
        .login-logo {
          position: absolute;
          top: 4%;
          left: 0%;
          height: 28px;
        }
        .login-car {
          position: absolute;
          bottom: calc(50% - 225px);
          right: 270px;
          height: 278px;
        }
        .login-box-banner {
          // width: 100%;
          position: absolute;
          bottom: calc(50% - 192px);
          right: 0;
          .login-box {
            // background-color: rgba(255, 255, 255, .2);
            width: 368px;
            // width:340px;
            height: 100%;
            border-radius: 20px;
            // border: solid 1px #fff;
            margin: 0 auto;
            position: relative;
            .login-inner {
              width: 340px;
              // height: 100%;
              // background-color: @bgcolor;
              background-color: white;
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              margin: auto;
              // border-radius: 20px;
              .login-tit {
                font-size: 18px;
                font-family: PingFangSC-Regular, sans-serif;
                font-weight: 400;
                color: rgba(1, 1, 1, 1);
                line-height: 22px;
                padding-bottom: 44px;
                text-align: center;
              }
              .error-message {
                font-size: 12px;
                text-align: center;
                padding: 6px 12px;
                position: absolute;
                top: 0;
                width: 100%;
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
                color: #a94442;
                background-color: #f2dede;
                border-color: #ebccd1;
              }
              .login-form {
                width: 80%;
                margin: 32px auto 0;
                .ivu-form-item {
                  /* margin-bottom: 30px; */
                }
                .ivu-checkbox-checked .ivu-checkbox-inner {
                  background-color: @login-color;
                  border-color: @login-color;
                }
                .login-forget {
                  color: @login-color;
                }
                .login-btn {
                  color: #fff;
                  background-color: @login-color;
                  &.ivu-btn:hover {
                    border-color: @login-color;
                    background-color: @login-center-bgcolor;
                  }
                }
              }
            }
          }
        }
        .login-ps {
          text-align: center;
          font-size: 12px;
          position: absolute;
          bottom: 30px;
          left: 0;
          right: 0;
          margin: 0 auto;
          div {
            margin-top: 10px;
          }
        }
      }
    }
  }

</style>
